module.exports = __webpack_public_path__ + "img/7.ae9225a1.jpg";